<ng-container *transloco="let t;">
<app-list-view [title]="t('common.labels.businessunits')" [messages]="messages" [loading]="loading">

  <div buttons>
    <button withRight="admin.businessunit.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
  </div>

  <div table>
    <p-table
      [value]="businessunits"
      [paginator]="true"
      [rows]="20"
      stateStorage="local"
      dataKey="name"
      stateKey="businessunit-list"
      [rowsPerPageOptions]="rowsPerPage"
      [showCurrentPageReport]="true"
      [currentPageReportTemplate]="t('common.labels.current_page_report')"
    >
      <ng-template pTemplate="colgroup">
        <colgroup>
            <col style="width: 40px;">
            <col>
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
            <th></th>
            <th pSortableColumn="name" aria-label="{{ t('common.labels.name') }}">{{ t('common.labels.name') }}
                <p-sortIcon field="name"></p-sortIcon>
            </th>
        </tr>
    </ng-template>
      <ng-template pTemplate="body" let-businessunit let-expanded="expanded">
        <tr tabindex="0" [ngClass]="{'expanded': expanded}">
          <td>
            <button type="button" pButton pRipple [pRowToggler]="businessunit" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
          </td>
          <td>{{ businessunit.name }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-businessunit>
        <tr *ngFor="let child of businessunit.businessunits" class="child">
          <td></td>
          <td style="padding-left: 50px;">{{ child.name }}</td>
        </tr>
        <tr class="child-border">
          <td colspan="2"></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="no-data">{{ t('common.labels.no_data') }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

</app-list-view>
</ng-container>
